import React, { useEffect, useCallback, useState} from 'react';
import {setExplorePersonSelected} from 'actions/index.js';
import ethereum from "decentralized/ethereum.js";
import {connect} from 'react-redux';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const ExploreToolbar = ({
    onNewList,
    personSelected,
    setPersonSelected,
    children
}) => { 
    let [userName, setUserName] = useState(undefined);
    let [toggled, setToggled] = useState(false);
    useEffect(() => {
        if (!personSelected) {
            setUserName(undefined);
        } else {
            ethereum.users.getUserName(personSelected).then(
                setUserName);
        }
    }, [personSelected, setUserName]);
    return (
        <div className="explore-toolbar">
          <div className="toolbar-btn">
            <ButtonDropdown
              className="view-dropdown"
              show={toggled ? "true" : "false"}
              isOpen={toggled}
              toggle={() => setToggled(!toggled)}>
              <DropdownToggle size="sm" caret color="primary">
                <img className="explore-commands-icon" src="/automation-icon-disabled.png"/>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={onNewList}
                  key=""
                  size="sm">
                  New List
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
          </div>
          {userName ? <div onClick={() => setPersonSelected(undefined)}
                           className="user-selected">{userName}</div> : ''}
          {children}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      personSelected: state.explore.personSelected
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPersonSelected : id => dispatch(setExplorePersonSelected(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExploreToolbar);
